import gql from 'graphql-tag';

export const PublishPageAsBlog =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation PublishPageAsBlogMutation(
			$contentId: String!
			$destinationType: String!
			$destinationSpaceKey: String
			$sourceStatus: String!
			$content: String
			$title: String
			$syncRev: String
			$ncsStepVersion: String
			$message: String
			$suppressNotifyWatchers: Boolean
			$schedulePublishDate: String
			$restrictions: ContentRestrictionsObj
		) @experimental {
			experimentalPublishPageAsBlog(
				contentId: $contentId
				destinationType: $destinationType
				destinationSpaceKey: $destinationSpaceKey
				sourceStatus: $sourceStatus
				content: $content
				title: $title
				syncRev: $syncRev
				ncsStepVersion: $ncsStepVersion
				message: $message
				suppressNotifyWatchers: $suppressNotifyWatchers
				schedulePublishDate: $schedulePublishDate
				restrictions: $restrictions
			) {
				id
				_links {
					webui
					editui
				}
				status
			}
		}
	`;
